module.exports = __webpack_public_path__ + "static/media/Victory.c36eb4ba.png";